import React, { useCallback, useEffect, useState } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { ChartRowObject } from '../../types/data'
import './DataTable.sass'
import { TableFooter, TablePagination } from '@mui/material'
import PositionIcon from '../PositionIcon/PositionIcon'

interface Props {
    data: ChartRowObject[]
    isPaginated?: boolean
}

const DataTable: React.FC<Props> = (props) => {
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(0)
    const [currentDataElements, setCurrentDataElements] = useState<ChartRowObject[]>([])

    useEffect(() => {
        if (props.data && props.data.length) setCurrentDataElements(props.data)
    }, [props.data])

    const getElementsToDisplay = useCallback(() => {
        if (props.isPaginated) {
            return currentDataElements.length > 0
                ? currentDataElements.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
                : currentDataElements
        }
        return currentDataElements
    }, [props.isPaginated, currentPage, currentDataElements, rowsPerPage])

    return (
        <TableContainer className="table-container" component={Paper}>
            <Table sx={{ minWidth: 300 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ maxWidth: 80 }}>Posizione</TableCell>
                        <TableCell>Nome</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {getElementsToDisplay().map((rowData) => (
                        <TableRow key={rowData.id_radio} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell sx={{ maxWidth: 80 }} component="th" scope="row">
                                <div className="row-container small-space-sx">
                                    <div>
                                        <b>{rowData.position}</b>
                                    </div>
                                    <div>
                                        <PositionIcon
                                            currentPosition={rowData.position}
                                            previousPosition={rowData.previous_position}
                                        />
                                    </div>
                                </div>
                            </TableCell>
                            <TableCell>
                                <div className="row-container">
                                    <div className="logo-container">
                                        <img src={rowData.logo} alt={rowData.name} />
                                    </div>
                                    <span className="bold-text">{rowData.name}</span>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                {props.isPaginated ? (
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, { label: 'All', value: -1 }]}
                                colSpan={3}
                                count={props.data.length}
                                rowsPerPage={rowsPerPage}
                                page={currentPage}
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    native: true,
                                }}
                                onPageChange={(e, newPage) => setCurrentPage(newPage)}
                                onRowsPerPageChange={(e) => {
                                    setRowsPerPage(parseInt(e.target.value, 10))
                                    setCurrentPage(0)
                                }}
                                // ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                ) : null}
            </Table>
        </TableContainer>
    )
}
export default DataTable

// const TablePaginationActions: React.FC<TablePaginationActionsProps> = (props) => {
//     const theme = useTheme()
//     const { count, page, rowsPerPage, onPageChange } = props

//     const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//         onPageChange(event, 0)
//     }

//     const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//         onPageChange(event, page - 1)
//     }

//     const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//         onPageChange(event, page + 1)
//     }

//     const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//         onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
//     }

//     return (
//         <Box sx={{ flexShrink: 0, ml: 2.5 }}>
//             <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
//                 {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
//             </IconButton>
//             <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
//                 {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
//             </IconButton>
//             <IconButton
//                 onClick={handleNextButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="next page"
//             >
//                 {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
//             </IconButton>
//             <IconButton
//                 onClick={handleLastPageButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="last page"
//             >
//                 {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
//             </IconButton>
//         </Box>
//     )
// }
